// src/components/common/ImageBox/ImageBox.tsx

import React, { CSSProperties } from 'react';

interface BgBoxProps {
  image: string;              // URL รูปภาพ
  title: string;              // ข้อความหัวเรื่อง
  subTitle: string;            // ข้อความรอง
  width?: string | number;    // ความกว้าง (optional)
  height?: string | number;   // ความสูง (optional)
  onClick?: () => void;       // ฟังก์ชันเมื่อคลิก (optional)
  style?: CSSProperties;      // Custom style (optional)
}

export const BgBox: React.FC<BgBoxProps> = ({ 
  image,
  title,
  subTitle,
  width = '100%',
  height = 'auto',
  onClick,
  style
}) => {
  return (
    <div 
      style={{
        width: width,
        height: height,
        position: 'relative',
        overflow: 'hidden',
        cursor: onClick ? 'pointer' : 'default',
        ...style
      }}
      onClick={onClick}
    >
      {/* รูปเต็ม Box */}
      <img 
        src={image}
        alt={title}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
      />
      
      {/* ข้อความด้านล่าง */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'linear-gradient(180deg, #D9D9D900 0%, #1A1A1AA3 100%);',
        color: 'white',
        padding: '40px 16px 3%',
        textAlign: 'center'
      }}>
        <p style={{ margin: 0, fontSize: 'clamp(28px, 6.5vw, 64px)', paddingBottom: '12px', fontFamily: 'Nandia' }}>{title}</p>
        <div style={{ border: '1px solid #FFFFFF40', justifySelf: 'center', width: '30%' }}></div>
        <p style={{ margin: 0, fontSize: 'clamp(18px, 3.5vw, 36px)', paddingTop: '24px', fontFamily: 'Nandia' }}> {subTitle}</p>
      </div>
    </div>
  );
};